import React, { useState } from "react";
import { Row, Col, Button, Form, Checkbox, Steps } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./Application4.css";
import "../components/StepsTracker.css";

const Application4: React.FC = () => {
  const [form] = Form.useForm();
  const [selectedPrograms, setSelectedPrograms] = useState<string[]>([]);

  const benefitPrograms = [
    {
      value: "none",
      label:
        "I have NOT participated in any of the qualifying programs listed below",
    },
    {
      value: "snap",
      label: "SNAP food assistance",
    },
    {
      value: "childcare",
      label: "Publicly funded childcare",
    },
    {
      value: "prc",
      label: "Prevention, Retention and Contingency (PRC) emergency assistance",
    },
    {
      value: "medicaid",
      label: "Medicaid",
    },
    {
      value: "tanf",
      label: "Temporary Assistance to Needy Families (TANF)",
    },
    {
      value: "housing",
      label: "Public Housing Benefits / Section 8 Voucher",
    },
    {
      value: "liheap",
      label: "Low Income Energy Assistance (LIHEAP)",
    },
    {
      value: "heap",
      label: "Home Energy Assistance (HEAP)",
    },
    {
      value: "pipp",
      label: "Percentage of Income Payment Plan (PIPP)",
    },
    {
      value: "lihwap",
      label: "Low Income Household Water Assistance Program (LIHWAP)",
    },
  ];

  const handleProgramChange = (checkedValues: string[]) => {
    setSelectedPrograms(checkedValues);
    // If "none" is selected, clear all other selections
    if (checkedValues.includes("none")) {
      const filteredValues = checkedValues.filter((value) => value === "none");
      setSelectedPrograms(filteredValues);
      form.setFieldsValue({ programs: filteredValues });
    } else {
      setSelectedPrograms(checkedValues);
    }
  };

  return (
    <div className="application-step-container">
      <div className="application-title-card">
        <div className="title-card-content">
          <div className="city-name-title">City of New Orleans, Louisiana</div>
          <h1 className="program-title-main">E-Bike Incentive Application</h1>
        </div>
      </div>

      <div className="progress-tracker-container">
        <Steps
          current={3}
          className="progress-tracker-steps"
          items={[
            { title: "Review Eligibility" },
            { title: "Confirm Details" },
            { title: "Personal Information" },
            { title: "Upload Documents" },
            { title: "Income Verification" },
            { title: "Survey" },
            { title: "Future Communications" },
            { title: "Terms & Conditions" },
          ]}
        />
      </div>

      <div className="main-step-card">
        <div className="step-header-container">
          <div className="step-badge">
            <div className="step-label">STEP</div>
            <div className="step-number">4</div>
          </div>
          <h2 className="step-title-main">
            Participation in Public Benefit Programs
          </h2>
        </div>

        <div className="step-divider" />

        <div className="form-section">
          <Form form={form} layout="vertical" className="benefit-programs-form">
            <div className="programs-question-section">
              <h3 className="question-title">
                In the past 12 months have you participated in any of the
                following qualifying programs?
              </h3>
              <p className="question-subtitle">Select all that apply.</p>

              <Form.Item name="programs" className="programs-form-item">
                <Checkbox.Group
                  value={selectedPrograms}
                  onChange={handleProgramChange}
                  className="programs-checkbox-group"
                >
                  <div className="programs-list">
                    {benefitPrograms.map((program) => (
                      <div
                        key={program.value}
                        className="program-checkbox-item"
                      >
                        <Checkbox
                          value={program.value}
                          disabled={
                            selectedPrograms.includes("none") &&
                            program.value !== "none"
                          }
                          className="program-checkbox"
                        >
                          <span className="program-label">{program.label}</span>
                        </Checkbox>
                      </div>
                    ))}
                  </div>
                </Checkbox.Group>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>

      <div className="navigation-buttons">
        <Link to="/application3">
          <Button
            type="default"
            icon={<ArrowLeftOutlined />}
            className="back-button"
          >
            Back
          </Button>
        </Link>
        <Link to="/application5">
          <Button type="primary" className="next-button" size="large">
            Next
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Application4;
